import React from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'

import './FeaturedPoster.css'

import {
  Title,
  Subtitle,
  Description,
  CtaLink,
  PageSection,
  Container,
  ContentContainer,
  FeaturedContentContainer,
  FeaturedContentInnerContainer,
  FeaturedContentClearfix,
  Image,
  FeaturedText,
} from './FeaturedPoster.css.js';

const FeaturedPoster = ({ config, content }) => {
  const { alignContent, backgroundColor, contentBackgroundColor, fontColor, sectionVerticalPaddingSize, showTopHorizontalLogo, showBottomVerticalLogo } = config;
  const { title, subtitle, description, ctaLink, ctaText, backgroundImage } = content;

  const renderBackgroundImage = () => (
    <Image
      alignContent={alignContent}
      backgroundImageUrl={backgroundImage}
      alt=""
    />
  );

  const renderCta = () => (
    <CtaLink href={ctaLink}>
      {ctaText}
    </CtaLink>
  );

  return (
    <PageSection
      backgroundColor={backgroundColor}
      fontColor={fontColor}
    >
      <Container
        removeGutters={true}
        sectionVerticalPaddingSize={sectionVerticalPaddingSize}
      >
        <ContentContainer
          alignContent={alignContent}
        >
          {renderBackgroundImage()}
          
          <FeaturedContentContainer
            alignContent={alignContent}
            backgroundColor={contentBackgroundColor}
          >
            <FeaturedContentInnerContainer>
              <FeaturedText
                alignContent={alignContent}
              >
                {title && (
                  <Title>
                    <ReactMarkdown
                      source={title}
                      escapeHtml={false}
                    />
                  </Title>
                )}

                {subtitle && (
                  <Subtitle>
                    <ReactMarkdown
                      source={subtitle}
                      escapeHtml={false}
                    />
                  </Subtitle>
                )}

                {description && (
                  <Description>
                    <ReactMarkdown
                      source={description}
                      escapeHtml={false}
                    />
                  </Description>
                )}

                {ctaText && ctaLink && renderCta()}
              </FeaturedText>

              <FeaturedContentClearfix />
            </FeaturedContentInnerContainer>
          </FeaturedContentContainer>
        </ContentContainer>
      </Container>
    </PageSection>
  );
}

FeaturedPoster.propTypes = {
  config: PropTypes.shape({
    alignContent: PropTypes.oneOf([`left`, `right`]).isRequired,
    backgroundColor: PropTypes.string,
    contentBackgroundColor: PropTypes.string,
    fontColor: PropTypes.string,
    sectionVerticalPaddingSize: PropTypes.oneOf([`x-large`, `large`, `medium`, `small`]),
    showTopHorizontalLogo: PropTypes.bool,
    showBottomVerticalLogo: PropTypes.bool,
  }),
  content: PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    description: PropTypes.string,
    ctaLink: PropTypes.string,
    ctaText: PropTypes.string,
    backgroundImage: PropTypes.string.isRequired,
  }),
}

export default FeaturedPoster;
